import { render, staticRenderFns } from "./OverlayItem.vue?vue&type=template&id=08257413&scoped=true"
import script from "./OverlayItem.vue?vue&type=script&lang=js"
export * from "./OverlayItem.vue?vue&type=script&lang=js"
import style0 from "./OverlayItem.vue?vue&type=style&index=0&id=08257413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08257413",
  null
  
)

export default component.exports